import { FC, ReactNode } from 'react'

interface NativeMenuSectionProps {
  sectionLabel: ReactNode | string
}

const NativeMenuSection: FC<NativeMenuSectionProps> = ({ sectionLabel }) => {
  return (
    <li className="mb-1 mt-5 w-full">
      <div className="flex h-[18px] cursor-text items-center gap-4 px-5 text-xs font-medium text-muted-foreground/70">
        <span className="capitalize">
          {sectionLabel}
        </span>
      </div>
    </li>
  )
}
NativeMenuSection.displayName = 'NativeMenuSection'
export { NativeMenuSection }
